import React from 'react'
import { history } from '../store'

import "../styles/QRsAdminView.css"

class ContractActiveList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        customer: '',
        serial: '',
        mode: '',
      },
      filterOpen: true
    };
  }
  goTo(id, e) {
    e.stopPropagation();
    history.push(`/contracts/${id}`)
  }

  goToCalendar(id, e) {
    e.stopPropagation();
    history.push(`/calendars/${id}`)
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  formatMinutesToHHMM = (minutes) => {
    const hrs = String(Math.floor(minutes / 60));
    const mins = String(minutes % 60).padStart(2, '0');
    return `${hrs}:${mins}`;
  };

  workingMode(type) {
    switch (type) {
      case "0":
        return "MTO DIARIO"
      case "1":
        return "MTO DIARIO + SERVICIOS"
      case "2":
        return "MTO DIARIO TIEMPO SIN PIN"
      case "3":
        return "MTO DIARIO TIEMPO CON PIN"
      case "4":
        return "OTO DIARIO SIN PIN"
      case "5":
        return "OTO DIARIO CON PIN"
      case "6":
        return "RESERVA ANTICIPADA"
      case "7":
        return "TAQUILLAS AQUARIAZ"
      case "8":
        return "PAQUETERÍA"
      case "9":
        return "WRISTBAND"
      case "11":
        return "APERTURA CON TELÉFONO"
    }
  }

  render() {
    const { filters, filterOpen } = this.state;
    const { contracts } = this.props;

    const filteredContractActive = contracts.filter(contract => {
      const { customer: customerFilter, serial: serialFilter, mode: modeFilter } = filters;

      if (
        customerFilter &&
        (!contract.Customer ||
          !contract.Customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        serialFilter &&
        (!contract.Machine ||
          !contract.Machine.Serial.toLowerCase().includes(serialFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        modeFilter &&
        contract.WorkingMode !== modeFilter) {
        return false;
      }

      return contract.Status !== "TERMINATED";
    });

    return (
      <div>
        {/* Filters (collapsible) */}
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={() => this.setState(prev => ({ filterOpen: !prev.filterOpen }))}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>

          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Serial</label>
                  <input type="text" placeholder="Serial" value={filters.serial} onChange={e => this.handleFilterChange('serial', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label>Cliente</label>
                  <input type="text" placeholder="Cliente" value={filters.customer} onChange={e => this.handleFilterChange('customer', e.target.value)} />
                </div>

                <div className="filter-group">
                  <label>Modo</label>
                  <select value={filters.mode} onChange={e => this.handleFilterChange('mode', e.target.value)}>
                    <option value="">Todos</option>
                    <option value="0">MTO DIARIO</option>
                    <option value="1">MTO DIARIO + SERVICIOS</option>
                    <option value="2">MTO DIARIO TIEMPO SIN PIN</option>
                    <option value="3">MTO DIARIO TIEMPO CON PIN</option>
                    <option value="4">OTO DIARIO SIN PIN</option>
                    <option value="5">OTO DIARIO CON PIN</option>
                    <option value="6">RESERVA ANTICIPADA</option>
                    <option value="7">TAQUILLAS AQUARIAZ</option>
                    <option value="8">PAQUETERÍA</option>
                    <option value="9">WRISTBAND</option>
                  </select>
                </div>

                <div className="filter-group filter-actions">
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn btn-light" onClick={() => this.setState({ filters: { customer: '', serial: '', mode: '' } })}>Limpiar</button>
                  </div>
                </div>

              </div>
            </div>
          )}
        </div>

        {/* Header */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-id">Máquina</div>
          <div className="qrs-header-col col-customer">Cliente</div>
          <div className="qrs-header-col col-payments">Tipo</div>
          <div className="qrs-header-col col-versions">Híbrido</div>
          <div className="qrs-header-col col-zone">Zona</div>
          <div className="qrs-header-col col-payments">Calendario</div>
          <div className="qrs-header-col col-payments">Fechas</div>
          <div className="qrs-header-col col-versions">Acceso</div>
          <div className="qrs-header-col col-actions">Estado</div>
        </div>

        {/* Card list */}
        <div className="qrs-admin-list">
          {filteredContractActive.sort((a, b) => a.Machine.Serial.localeCompare(b.Machine.Serial)).map(contract => {
            const statusClass = 'ENABLED'
            return (
              <div key={contract._id} className="qrs-admin-card" onClick={e => this.goTo(contract._id, e)}>
                <div className="qrs-admin-row">
                  <div className={`qrs-admin-status-bar ${statusClass}`}></div>
                  <div className="qrs-admin-content">

                    <div className="qrs-admin-machine-id">
                      <div className="qrs-admin-code">{contract.Machine.Serial}</div>
                    </div>

                    <div className="qrs-admin-machine-customer">
                      <div className="qrs-admin-customer-name">{contract.Customer.Fullname}</div>
                    </div>

                    <div className="qrs-admin-machine-payments">
                      <div className="qrs-admin-sub">{this.workingMode(contract.WorkingMode)} { (contract.WorkingMode === "2" || contract.WorkingMode === "3") ? `( ${this.formatMinutesToHHMM(contract.TimeSlots)} )` : '' }</div>
                    </div>

                    <div className="qrs-admin-machine-versions">
                      <div className="qrs-admin-sub"><span className={`badge ${contract.HybridMode ? 'badge-success' : 'badge-secondary'}`}><i className={`fas ${contract.HybridMode ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>{contract.HybridMode ? 'Sí' : 'No'}</span></div>
                    </div>

                    <div className="qrs-admin-machine-zone">
                      <div className="qrs-admin-zone">{contract.Zone}</div>
                    </div>

                    <div className="qrs-admin-machine-payments">
                      <button className="qrs-admin-card-action-btn update" onClick={(e) => { e.stopPropagation(); this.goToCalendar(contract.Calendar?._id, e) }}>{contract.Calendar ? contract.Calendar.Name : 'Precios fijos'}</button>
                    </div>

                    <div className="qrs-admin-machine-payments">
                      <div className="qrs-admin-sub">{(new Date(contract.StartDate)).toDateString()}<br />{(new Date(contract.EndDate)).toDateString()}</div>
                    </div>

                    <div className="qrs-admin-machine-versions">
                      <div className="qrs-admin-sub">{contract.DoorAccess}</div>
                    </div>

                    <div className="qrs-admin-machine-actions">
                      <div className="qrs-admin-sub">{contract.Status}</div>
                    </div>

                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default ContractActiveList

